import { IMeta, IPagination, ISort } from "@delanobgt/admin-core/util/types";
import { produce } from "immer";
import { Reducer } from "redux";
import {
  EWithdrawRequestSortField,
  IWithdrawRequest,
  PWithdrawRequestFilter,
} from "src/core/withdrawRequest/entities";
import { ActionType, createAction, getType } from "typesafe-actions";

/*
 * state
 */
export interface IWithdrawRequestState {
  withdrawRequests: IWithdrawRequest[];
  loading: boolean;
  error: any;
  meta: IMeta;
}

const initialState: IWithdrawRequestState = {
  withdrawRequests: [],
  loading: false,
  error: null,
  meta: {
    limit: 10,
    offset: 0,
    total: 0,
  },
};

/*
 * action types
 */
const FETCH_REQUESTED = "withdraw-request/FETCH_REQUESTED";
const FETCH_SUCCEEDED = "withdraw-request/FETCH_SUCCEEDED";
const FETCH_FAILED = "withdraw-request/FETCH_FAILED";
const POLLING_START_REQUESTED = "withdraw-request/POLLING_START_REQUESTED";
const POLLING_STOP_REQUESTED = "withdraw-request/POLLING_STOP_REQUESTED";

/*
 * action creators
 */
export const actions = {
  fetchRequested: createAction(FETCH_REQUESTED)(),

  fetchSucceeded: createAction(FETCH_SUCCEEDED)<{
    data: IWithdrawRequest[];
    meta: IMeta;
  }>(),

  fetchFailed: createAction(FETCH_FAILED)<any>(),

  pollingStartRequested: createAction(POLLING_START_REQUESTED)<{
    filter: PWithdrawRequestFilter;
    pagination: IPagination;
    sorts: ISort<EWithdrawRequestSortField>[];
    refreshDelay: number;
  }>(),

  pollingStopRequested: createAction(POLLING_STOP_REQUESTED)(),
};
export type TActions = ActionType<typeof actions>;

const reducer: Reducer<IWithdrawRequestState, TActions> = (
  state = initialState,
  action
) => {
  return produce<IWithdrawRequestState>(state, (draft) => {
    switch (action.type) {
      case getType(actions.fetchRequested): {
        draft.loading = true;
        draft.error = null;
        break;
      }
      case getType(actions.fetchSucceeded): {
        const {
          payload: { data, meta },
        } = action;
        draft.withdrawRequests = data;
        draft.loading = false;
        draft.error = null;
        draft.meta = meta;
        break;
      }
      case getType(actions.fetchFailed): {
        const { payload } = action;
        draft.loading = false;
        draft.error = payload;
        break;
      }
    }
  });
};

export default reducer;
